/** @format */

import React, { Component } from 'react';
import { Segment, Header, Grid, Statistic, Divider } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';

@inject('StatsStore')
@observer
class StatsOverview extends Component {
  render() {
    const { StatsStore } = this.props;
    const { counters } = StatsStore.stats;
    return (
      <Segment textAlign="center">
        <Header as="h3" children="Overview Richieste" />
        <Divider />
        <Grid columns="4">
          <Grid.Row>
            <Grid.Column textAlign="center">
              <Statistic size="mini">
                <Statistic.Value>{counters.counter}</Statistic.Value>
                <Statistic.Label>Richieste Totali</Statistic.Label>
              </Statistic>
            </Grid.Column>
            <Grid.Column textAlign="center">
              <Statistic size="mini">
                <Statistic.Value>{counters.sold}</Statistic.Value>
                <Statistic.Label>Con Vendita</Statistic.Label>
              </Statistic>
            </Grid.Column>
            <Grid.Column textAlign="center">
              <Statistic size="mini">
                <Statistic.Value>{counters.unsold}</Statistic.Value>
                <Statistic.Label>Senza Vendite</Statistic.Label>
              </Statistic>
            </Grid.Column>
            <Grid.Column textAlign="center">
              <Statistic size="mini">
                <Statistic.Value>{counters.unsoldUnavailable}</Statistic.Value>
                <Statistic.Label>Non disponibili</Statistic.Label>
              </Statistic>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid columns="4">
          <Grid.Row>
            <Grid.Column textAlign="center">
              <Statistic size="mini">
                <Statistic.Value>{counters.active}</Statistic.Value>
                <Statistic.Label>Attive</Statistic.Label>
              </Statistic>
            </Grid.Column>
            <Grid.Column textAlign="center">
              <Statistic size="mini">
                <Statistic.Value>{counters.archived}</Statistic.Value>
                <Statistic.Label>Archiviate</Statistic.Label>
              </Statistic>
            </Grid.Column>
            <Grid.Column textAlign="center">
              <Statistic size="mini">
                <Statistic.Value>
                  {((counters.sold * 100) / counters.counter).toFixed(2)}%
                </Statistic.Value>
                <Statistic.Label>Conversione</Statistic.Label>
              </Statistic>
            </Grid.Column>
            <Grid.Column textAlign="center">
              <Statistic size="mini">
                <Statistic.Value>
                  {counters.soldItemsAverageCount.toFixed(2)}
                </Statistic.Value>
                <Statistic.Label>Ricambi/Vendita</Statistic.Label>
              </Statistic>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

export default StatsOverview;
